import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import HeaderComponent from '../HeaderComponent';

import { formatNumber } from '../../service/market';

import css from '../../styles/instrument/recommendations';

class Recommendations extends Component {
    static propTypes = {
        RECOM_BUY: PropTypes.number,
        RECOM_HOLD: PropTypes.number,
        RECOM_OVERWEIGHT: PropTypes.number,
        RECOM_SELL: PropTypes.number,
        RECOM_UNDERWEIGHT: PropTypes.number,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this._getSum = () => [
            this.props.RECOM_BUY, this.props.RECOM_HOLD, this.props.RECOM_OVERWEIGHT,
            this.props.RECOM_SELL, this.props.RECOM_UNDERWEIGHT,
        ].reduce((a, b) => a + b);

        this._getMax = () => [
            this.props.RECOM_BUY, this.props.RECOM_HOLD, this.props.RECOM_OVERWEIGHT,
            this.props.RECOM_SELL, this.props.RECOM_UNDERWEIGHT,
        ].reduce((a, b) => Math.max(a, b));
    }

    renderSum(sum, height) {
        const lineheight = 88;
        const className = [css.sum];

        if (lineheight < height) {
            className.push(css.invert);
        }

        if (sum === this._getMax()) {
            className.push(css.emphasize);
        }

        return (
            <div className={className.join(' ')}>
                <span>{sum}</span>
            </div>
        );
    }

    renderBars() {
        const {
            RECOM_BUY, RECOM_HOLD, RECOM_OVERWEIGHT, RECOM_SELL, RECOM_UNDERWEIGHT,
            t,
        } = this.props;

        const columns = [];
        const recommendations = [
            [t('buy'), '#419E2C', RECOM_BUY],
            [t('overweight'), '#1F660F', RECOM_HOLD],
            [t('hold'), '#6A6A6A', RECOM_OVERWEIGHT],
            [t('underweight'), '#9C1116', RECOM_SELL],
            [t('sell'), '#DA282E', RECOM_UNDERWEIGHT],
        ];

        const sum = this._getSum();
        const max = this._getMax();

        const lineheight = 17;

        for (const [name, color, prop] of recommendations) {
            const height = (prop / max) * 100;
            const style = {
                height: `${height}%`,
                backgroundColor: color,
            };

            columns.push(
                <div key={name} className={css.item}>
                    <div className={css.barWrap}>
                        <div className={css.bar} style={style}>
                            {height > lineheight &&
                                <div className={css.percentage}>
                                    <span>{formatNumber((prop / sum) * 100, 1)}%</span>
                                </div>
                            }
                            { this.renderSum(prop, height) }
                        </div>
                    </div>
                    <div className={css.itemTitle}>
                        <span>{name}</span>
                    </div>
                </div>
            );
        }

        return columns;
    }

    render() {
        if (!this.props.RECOM_BUY && !this.props.RECOM_HOLD && !this.props.RECOM_OVERWEIGHT
            && !this.props.RECOM_SELL && !this.props.RECOM_UNDERWEIGHT) {
            return null;
        }

        const { t } = this.props;

        return (
            <HeaderComponent title={t('title')}>
                <div className={css.bars}>
                    { this.renderBars() }
                </div>
            </HeaderComponent>
        );
    }
}

export default translate('recommendations')(Recommendations);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Recommendations.js
 **/